import { WrenchClockIcon } from './WrenchClockIcon';

/**
 * author: Simran
 * id 922891A9-0422-4BCD-9CE7-2FA1E7134EAB
 * name wrench-clock
 * version: 6.5.95
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/wrench-clock.svg
 * tags
 * - Date / Time 
 * - Hardware / Tools 
 */
export const ToolClockIcon = WrenchClockIcon;
export default ToolClockIcon